import * as React from 'react';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../redux/selectors/resources';
import View from './view';

export const CashBackProgramScreen: React.FC = () => {
  const content = useSelector(contentSelector());

  return <View content={content} />;
};
